// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "modules/" + chunkId + "-b1-" + {"639":"5966ade1e8f0c3d6dba0","951":"ae46bc396e22f3efed81","966":"5bfd07a49d9758fbb078"}[chunkId] + ".js";
};